import { Injectable } from "@angular/core";
import { IHealthcareservice } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "../shared/api/api.service";
import { BaseApiService } from "../shared/api/baseApi.service";

@Injectable({
  providedIn: "root",
})
export class HealthcareserviceApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "HealthCareServices", // Theme !
      [], // Post route paths
      ["services"], // Get route paths
      [], // Update route paths
      [] // Delete route paths
    );
  }

  public list(organizationId?: string): Observable<IHealthcareservice[]> {
    return this.api.get(this.readRoutes[0], {
      identifier: organizationId,
    }) as Observable<IHealthcareservice[]>;
  }
}
